import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AssetUriService } from "@aiwyn/config";

@Injectable({
  providedIn: 'root'
})
export class BrandingGuard  {

  constructor(private router: Router, private assetsUriService: AssetUriService, private activatedRoute: ActivatedRoute) {
  }

  /**
   * Ensure branding query param is always present for sub-branding if multiple branding is enabled and brand was
   * originally included in entry url
   * @param next
   * @param state
   *
   */
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.assetsUriService.brandingOffice && !next.queryParams[this.assetsUriService.brandingOfficeKey]) {
      this.router.navigate([state.url.split("?")[0]], {
        queryParams: {
          [this.assetsUriService.brandingOfficeKey]: this.assetsUriService.brandingOffice, ...next.queryParams
        },
        relativeTo: this.activatedRoute
      });
      return false;
    }
    return true;
  }

}
